/**
 * Toast do cofre: distribui o `showToast` por CONTEXTO (dialogs profundos
 * disparam 'Senha copiada' etc. sem prop-drilling); a apresentação vem do
 * useTransientToast compartilhado (variante 'success', 2.5s).
 */
import { createContext, useContext, type ReactNode } from 'react';
import { useTransientToast } from '@/components/ui/transient-toast';

const ToastContext = createContext<(message: string) => void>(() => {});

export function useVaultToast() {
  return useContext(ToastContext);
}

export function VaultToastProvider({ children }: { children: ReactNode }) {
  const { toast, showToast } = useTransientToast('success', 2500);
  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {toast}
    </ToastContext.Provider>
  );
}
